import { render, staticRenderFns } from "./CompanyLink.vue?vue&type=template&id=df2049fa&scoped=true"
import script from "./CompanyLink.vue?vue&type=script&lang=js"
export * from "./CompanyLink.vue?vue&type=script&lang=js"
import style0 from "./CompanyLink.vue?vue&type=style&index=0&id=df2049fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2049fa",
  null
  
)

export default component.exports